import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CAQuestion } from 'src/app/core-module/models/ExternalAudits/ca-question';

@Component({
    selector: 'app-public-audit-question',
    templateUrl: './public-audit-question.component.html',
    styleUrl: './public-audit-question.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublicAuditQuestionComponent {
  @Input() auditQuestion:CAQuestion
  @Input() firstQuestion:boolean = false;
  @Input() lastQuestion:boolean = false;
  @Output() auditQuestionChange = new EventEmitter<CAQuestion>;

}
